import { Flex } from '@chakra-ui/react';
import { Link } from '@morressier/alembic';
import { CopyrightFooter } from '../Footer';
import { useState } from 'react';
import ContactUsProvider from 'src/pages/ContactUs/ContactUsProvider';
import { PRIVACY_POLICY_URL } from '../../cookies/config';
import HelpCenterDrawer from '../HelpCenter/HelpCenterDrawer';

const CopyrightFooterSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const APP_ENV = import.meta.env.VITE_APP_ENV;

  return (
    <Flex
      gap={3}
      justifyContent={'center'}
      as={'footer'}
      alignItems={'center'}
      py={3}
      textStyle={'textContext'}
      flexWrap="wrap"
      px={{ base: 4, md: 0 }}
    >
      <CopyrightFooter />
      <Flex
        gap={{ base: 2, md: 3 }}
        textStyle="textContext"
        alignItems="center"
        justifyContent={{ base: 'flex-start', md: 'flex-end' }}
        wrap="wrap"
        flexShrink={0}
      >
        {APP_ENV === 'staging' && (
          <Link
            href={`#`}
            variant="secondary"
            onClick={() => setIsHelpModalOpen(true)}
          >
            Help Center
          </Link>
        )}
        <Link variant="primary" href={PRIVACY_POLICY_URL} target="_blank">
          Terms and Conditions
        </Link>
        <Link variant="primary" target="_blank" href={PRIVACY_POLICY_URL}>
          Privacy Policy
        </Link>
        <Link
          variant="secondary"
          href={`#`}
          ml={1}
          onClick={() => setIsOpen(true)}
        >
          Contact Support
        </Link>
        {isOpen && (
          <ContactUsProvider
            isLoggedIn={false}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        )}
        {isHelpModalOpen && (
          <HelpCenterDrawer
            isOpen={isHelpModalOpen}
            setIsOpen={setIsHelpModalOpen}
            isLoggedIn={false}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default CopyrightFooterSection;
